<template>
  <div class="page__wr">
    <div class="events">

      <div class="events__content">
        <div class="events__title-items-wr">
          <div class="about__title-wr title-oblique-line-anima">
            <h1 class="events__title title-anima">{{ h1 }}</h1>
          </div>
          <div class="events__tab-title-items">
            <div @click="setActiveTab('past')"
                 :class="{'events__tab-title-item' : true, 'events__tab-title-item--active' : activeTab === 'past'}">
              Прошедшие
            </div>
            <div @click="setActiveTab('future')"
                 :class="{'events__tab-title-item' : true, 'events__tab-title-item--active' : activeTab === 'future'}">
              Предстоящие
            </div>
            <div @click="setActiveTab('info')"
                 :class="{'events__tab-title-item' : true, 'events__tab-title-item--active' : activeTab === 'info'}">
              Информация
            </div>
          </div>
        </div>


        <div class="events__tabs-content">

          <div class="events__tabs-content-item"
               v-if="activeTab === 'past'">
            <div class="gallery">
              <div class="gallery__content">
                <div class="gallery__slider js-gallery-slider-events">
                  <div class="swiper-container"
                       ref="swiperContainer">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide"
                           v-for="slide in galleryItems"
                           :key="slide.link">
                        <a target="_blank"
                           class="gallery__slider-item"
                           :href="slide.link">
                          <div class="gallery__slider-img gallery__slider-img--big"
                               v-if="slide.img"
                               :style="`background-image: url(${slide.img})`">
                          </div>
                          <div class="gallery__slider-date"
                               v-if="slide.date"
                               v-html="slide.date"></div>
                          <div class="gallery__slider-title"
                               v-if="slide.title"
                               v-html="slide.title"></div>
                          <div class="gallery__slider-type"
                               v-if="slide.type"
                               v-html="item.type"></div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="gallery__slider-pagination-wr">
                    <div class="swiper-button-prev">
                      <SvgIcon class="gallery__slider-ico"
                               name="arrow-left"
                               width="7"
                               height="11"></SvgIcon>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-next">
                      <SvgIcon class="gallery__slider-ico"
                               name="arrow-left"
                               width="7"
                               height="11"></SvgIcon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="events__tabs-content-item-events">
              <EventItem v-for="item in past"
                         :key="item.id"
                         :item="item"
                         :setImg="setImg"
                         type="past" />
            </div>
          </div>
          <div class="events__tabs-content-item"
               v-if="activeTab === 'future'">
          </div>
          <div class="events__tabs-content-item"
               v-if="activeTab === 'info'">
            <div class="guests__wr">
              <div class="guests__content">
                <div class="guests__message">
                  <div class="guests__message-content"
                       v-if="infoText"
                       v-html="infoText"></div>
                </div>
              </div>
            </div>
          </div>

        </div>


      </div>
      <div :class="{'events__bottom-nav-future' : activeTab === 'future'}">
        <BottomNav :links="links"></BottomNav>
      </div>
      <Samedia />
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus';
import EventItem from '@/components/common/eventItem/EventItem.vue';
import BottomNav from '@/components/common/bottomNav/bottomNav.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PerfectScrollbar from 'perfect-scrollbar';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import SvgIcon from "@/components/common/svgIcon/SvgIcon.vue";
import {determineWindowSize} from '@/mixins/determineWindowSize.js';

export default {
  name: 'Events',

  mixins: [AjaxHelpersVue, determineWindowSize],

  components: {
    SvgIcon,
    EventItem,
    BottomNav,
    Samedia
  },

  data() {
    return {
      countOfSlideInPage: 0,
      past: false,
      activeTab: 'past',
      infoText: false,
      galleryItems: false,
      links: {
        prev: {
          href: "/o-nas",
          txt: "О нас"
        },
        next: {
          href: "/menyu",
          txt: "Меню"
        }
      },
      imgLeft: null,
      imgRight: null,
    }
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadEventsPage', url => {
      this.request(url);
      this.setInfoText();
    });
  },

  methods: {

    requestGallery(url) {

      PrologueClient.queryToServer('GalleryPage:getGalleryPage', {url}, res => {

        this.galleryItems = res.content.items;

        this.determineWindowSize();


        this.$nextTick(() => {
          this.initSlider();
        });

        EventBus.$emit('pageDone');

      });
    },

    initSlider() {
      let $slider = $('.js-gallery-slider-events');
      let $sliderNextBtn = $slider.find('.swiper-button-next');
      let $sliderPrevBtn = $slider.find('.swiper-button-prev');
      let $sliderPagination = $slider.find('.swiper-pagination');

      if ($slider.find('.swiper-slide-active').length) return;

      let sliderParams = {
        init: false,
        autoplay: {
          delay: 3000
        },
        slidesPerView: this.countOfSlideInPage,
        spaceBetween: 10,
        navigation: {
          nextEl: $sliderNextBtn,
          prevEl: $sliderPrevBtn
        },
        pagination: {
          el: $sliderPagination,
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 10,
        },
        breakpoints: {
          1400: {
            pagination: {
              dynamicMainBullets: 4,
            }
          }
        },
        //loop: true, // в цикле не работают события вью из-за клонирования слайдов без событий
        simulateTouch: true,
        observer: true, // если слайдер изначально скрыт
        observeParents: true // если слайдер изначально скрыт
      };

      if ($slider.find('.gallery__slider-item').length <= 3) {
        $.extend(sliderParams, {
          loop: false,
          virtualTranslate: true
        });

        $sliderNextBtn.hide();
        $sliderPrevBtn.hide();
        $sliderPagination.hide();
      }

      if ($slider.length) {
        let swiper = new Swiper(this.$refs.swiperContainer, sliderParams)


        swiper.init();


        $('[data-id="events"]').css({'opacity': '1'});
      }
    },

    setInfoText() {

      const url = '/gosti';

      this.req('GuestsPage:getGuestsPage', {url}, res => {
        this.infoText = res.content.message;
      });

    },

    setActiveTab(tab) {
      this.activeTab = tab;

      if (tab === 'past') {
        this.$nextTick(() => {
          this.initSlider();
        });
      }

    },

    request(url) {

      this.req('EventsPage:getEventsPage', {url}, res => {

        if (this.checkProperty(res.content.future)) {
          this.future = res.content.future;
        }

        if (this.checkProperty(res.content.past)) {
          this.past = res.content.past;
        }

        this.requestGallery('/galereya');


      }, 'events');
    },


    setImg(id, type) {
      if (type === 'future') {
        this.processImg(this.future, id);
      } else if (type === 'past') {
        this.processImg(this.past, id);
      }
    },

    processImg(data, id) {
      data.forEach((month, i) => {

        month.items.forEach((day, j) => {
          if (day.id == id) {
            let imgLeft = this.future[i].items[j].imgLeft || '';
            let imgRight = this.future[i].items[j].imgRight || '';

            $('.events__tab-items').addClass('events__tab-items--hover');

            // let tmplImgLeft  = `<div class="events__tab-item-img-left" style="background-image: url(${require(`@/assets/img/events/${imgLeft}`)})"></div>`;
            let tmplImgLeft = `<div class="events__tab-item-img-left" style="background-image: url(${imgLeft});"></div>`;
            let tmplImgRight = `<div class="events__tab-item-img-right" style="background-image: url(${imgRight});"></div>`;

            $('.events__tab-item-img-left-wr').append(tmplImgLeft);
            $('.events__tab-item-img-right-wr').append(tmplImgRight);

            setTimeout(() => {
              $('.events__tab-item-img-left').last().addClass('events__tab-item-img-left--active');
              $('.events__tab-item-img-right').last().addClass('events__tab-item-img-right--active');
            }, 100)
          }
        });
      });
    },

    scrollInit(scrollBlock) {

      if ($(scrollBlock).length && !$(scrollBlock).hasClass('ps')) {
        new PerfectScrollbar(scrollBlock, {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20
        });

        //ps.destroy();
        //ps = null;
      }
    },

  }
}
</script>

<style>
.events {
  height: 96%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


.events__tabs-content {
  margin-top: 40px;
}


.events__tabs-content-item-events {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 80px;
  height: calc(100vh - 559px);
  overflow-y: scroll;
}


.events .gallery__content {
  margin-top: 0 !important;
  min-height: auto !important;
}


.events__title-wr {
  position: relative;
  display: inline-flex
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__title-wr:before {
    content: "";
    height: 1px;
    background: #686868;
    position: absolute;
    width: 80px;
    right: -80px;
    bottom: 25px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) and (min-width: 1600px) and (min-height: 930px) {
  .events__title-wr:before {
    width: 170px;
    right: -140px;
    bottom: 30px
  }
}


.events__title {
  letter-spacing: .18em;
  font-size: 2.375rem;
  text-transform: uppercase;
  padding: 0 35px;
  margin: 40px 0 20px;
  text-align: center;
  width: 100vw;

  box-sizing: border-box
}


@media screen and (min-width: 700px) {
  .events__title {
    text-align: left;
    width: auto;

    box-sizing: content-box
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__title {
    font-size: 2.125rem;
    padding-left: 0;
    margin: 26px 0 0
  }
}


@media screen and (min-width: 1200px) and (min-height: 670px) {
  .events__title {
    font-size: 2.5rem
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__title {
    font-size: 3.75rem
  }
}


.events__title-items-wr {
  display: flex;
  flex-direction: column
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__title-items-wr {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}


.events__tab-title-items {


  display: flex;
  margin: 0 36px;
  -ms-flex-pack: distribute;
  justify-content: space-around
}


@media screen and (min-width: 700px) {
  .events__tab-title-items {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-title-items {
    margin: 0
  }
}


.events__tab-title-item {
  font-size: 1rem;
  text-transform: lowercase;
  position: relative;
  font-family: pfdindisplaypro-light, Helvetica, Arial, sans-serif;
  margin-right: 20px;
  cursor: pointer;

  transition: all .25s ease-in-out
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-title-item {
    margin-right: 50px;
    font-size: 1.125rem
  }
}


.events__tab-title-item:last-child {
  margin-right: 0
}


.events__tab-title-item:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -16px;
  width: 100%;
  height: 1px;
  background: #62b6f2;
  opacity: 0;
  visibility: hidden;

  transition: all .25s ease-in-out
}


.events__tab-title-item:hover {
  color: #62b6f2
}


.events__tab-title-item:hover:before {
  bottom: -8px;
  opacity: 1;
  visibility: visible
}


.events__tab-title-item--active {
  color: #62b6f2;
  cursor: default;
  pointer-events: none
}


.events__tab-title-item--active:before {
  bottom: -8px;
  opacity: 1;
  visibility: visible
}


.events__tab-items {
  margin-top: 40px;
  position: relative
}


@media screen and (min-width: 700px) {
  .events__tab-items {
    min-height: 49vh
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-items {
    min-height: auto;
    margin-top: 30px
  }
}


@media screen and (min-width: 1200px) and (min-height: 670px) {
  .events__tab-items {
    margin-top: 40px
  }
}


@media screen and (min-width: 1900px) and (min-height: 960px) {
  .events__tab-items {
    margin-top: 115px;
    min-height: auto
  }
}


.events__tab-items--hover .events__tab-item-img-left-wr {
  left: -270px;
  opacity: 1;
  visibility: visible
}


.events__tab-items--hover .events__tab-item-img-right-wr {
  right: -300px;
  opacity: 1;
  visibility: visible
}


.events__tab-item {
  height: 100%;

  transition: opacity .25s ease-in-out, visibility .25s ease-in-out;
  top: 0;
  left: 0;
  width: 100%
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-item {
    height: 300px
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__tab-item {
    height: 400px
  }
}


.events__tab-item--active {
  display: block;
  opacity: 1;
  visibility: visible;
  position: relative;
  z-index: 100
}


.events__tab-item-img-left-wr {
  position: absolute;
  bottom: -60px;
  left: -400px;
  width: 209px;
  height: 209px;
  -webkit-transition: left .25s ease-in-out, opacity .25s ease-in-out, visibility .25s ease-in-out;
  transition: left .25s ease-in-out, opacity .25s ease-in-out, visibility .25s ease-in-out;
  will-change: left, opacity, visibility;
  opacity: 0;
  visibility: hidden;
  display: none
}


@media screen and (min-width: 1900px) and (min-height: 960px) {
  .events__tab-item-img-left-wr {
    display: block
  }
}


.events__tab-item-img-left {
  position: absolute;
  width: 209px;
  height: 209px;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;

  transition: all .25s ease-in-out
}


.events__tab-item-img-left--active {
  opacity: 1
}


.events__tab-item-img-right-wr {
  position: absolute;
  top: -70px;
  right: -400px;
  width: 268px;
  height: 268px;
  -webkit-transition: right .25s ease-in-out, opacity .25s ease-in-out, visibility .25s ease-in-out;
  transition: right .25s ease-in-out, opacity .25s ease-in-out, visibility .25s ease-in-out;
  will-change: left, opacity, visibility;
  opacity: 0;
  visibility: hidden;
  display: none
}


@media screen and (min-width: 1900px) and (min-height: 960px) {
  .events__tab-item-img-right-wr {
    display: block
  }
}


.events__tab-item-img-right {
  position: absolute;
  top: 0;
  left: 0;
  width: 268px;
  height: 268px;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;

  transition: all .25s ease-in-out
}


.events__tab-item-img-right--active {
  opacity: 1
}


.events__tab-content-items {
  display: grid;
  grid-template-columns: repeat(1, 245px);
  grid-row-gap: 50px;
  justify-content: space-between;
  margin-left: 35px
}


@media screen and (min-width: 360px) {
  .events__tab-content-items {
    grid-template-columns: repeat(1, 305px)
  }
}


@media screen and (min-width: 410px) {
  .events__tab-content-items {
    grid-template-columns: repeat(1, 340px)
  }
}


@media screen and (min-width: 700px) {
  .events__tab-content-items {
    grid-template-columns: repeat(3, 220px);
    margin-right: 35px
  }
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-content-items {
    grid-template-columns: repeat(3, 245px);
    grid-row-gap: 80px;
    margin-right: 130px;
    margin-left: 0
  }
}


.events__tab-content-title {
  letter-spacing: .04em;
  font-size: 1.25rem;
  font-family: pfdindisplaypro-bold, Helvetica, Arial, sans-serif;
  color: #62b6f2;
  text-transform: uppercase;
  border-bottom: 1px solid #62b6f2;
  padding-bottom: 6px
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-content-title {
    font-size: 1.5rem
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__tab-content-title {
    font-size: 1.75rem;
    padding-bottom: 12px
  }
}


.events__tab-content-dates {
  margin-top: 15px
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__tab-content-dates {
    margin-top: 25px
  }
}


.events__tab-content-date {
  margin-bottom: 24px;
  cursor: pointer
}


.events__tab-content-date:last-child {
  margin-bottom: 0
}


.events__tab-content-date:hover .events__tab-content-day {
  color: #62b6f2
}


.events__tab-content-day {
  letter-spacing: .04em;
  font-size: 1.0625rem;
  font-family: pfdindisplaypro-bold, Helvetica, Arial, sans-serif;

  transition: all .25s ease-in-out;
  position: relative
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-content-day {
    font-size: 1.25rem
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__tab-content-day {
    font-size: 1.5rem
  }
}


.events__tab-content-time-wr {
  display: flex;
  letter-spacing: .04em;
  font-size: .875rem;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  opacity: .61;
  margin-top: 3px
}


@media screen and (min-width: 1200px) and (min-height: 600px) {
  .events__tab-content-time-wr {
    font-size: 1rem
  }
}


@media screen and (min-width: 1600px) and (min-height: 930px) {
  .events__tab-content-time-wr {
    font-size: 1.125rem;
    margin-top: 8px
  }
}


.events__tab-content-time {
  font-family: pfdindisplaypro-bold, Helvetica, Arial, sans-serif;
  margin-right: 6px
}
</style>
